import { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import { useTenant } from "../../../../hooks/useTenant";
import WorkoutTemplateService from "../../../../services/workout_template_service";

/**
 * Hook para gerenciar modelos de treino (CRUD).
 */
export const useWorkoutTemplates = () => {
    const { idTenant, user: authUser } = useTenant();

    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    const loadTemplates = useCallback(async () => {
        if (!idTenant) return;
        setLoading(true);
        try {
            const data = await WorkoutTemplateService.getAll(idTenant);
            setTemplates(data || []);
            setError(null);
        } catch (err) {
            setError(err.message || "Erro ao carregar modelos.");
        } finally {
            setLoading(false);
        }
    }, [idTenant]);

    useEffect(() => {
        loadTemplates();
    }, [loadTemplates]);

    const handleSave = async (templateData) => {
        if (!idTenant || !authUser) return null;
        setSaving(true);
        try {
            const saved = await WorkoutTemplateService.save(templateData, idTenant, authUser);
            await loadTemplates();
            toast.success(templateData.id ? "Modelo atualizado!" : "Modelo criado com sucesso!");
            return saved;
        } catch (err) {
            setError(err.message || "Erro ao salvar modelo.");
            toast.error(err.message || "Erro ao salvar modelo.");
            return null;
        } finally {
            setSaving(false);
        }
    };

    const handleDelete = async (templateId, templateTitle) => {
        if (!idTenant || !authUser || !templateId) return false;
        setSaving(true);
        try {
            await WorkoutTemplateService.delete(templateId, idTenant, authUser, templateTitle);
            await loadTemplates();
            toast.success("Modelo removido com sucesso!");
            return true;
        } catch (err) {
            setError(err.message || "Erro ao deletar modelo.");
            toast.error(err.message || "Erro ao deletar modelo.");
            return false;
        } finally {
            setSaving(false);
        }
    };

    return {
        templates,
        loading,
        saving,
        error,
        reload: loadTemplates,
        handleSave,
        handleDelete,
    };
};
